import colours from "../../theme/colours";

const METRIC_VISUALS = {
  default: {
    className: "text-typography",
    color: colours.typography,
  },
  sky: {
    className: "text-sky-700",
    color: "#0369a1",
  },
  cyan: {
    className: "text-cyan-700",
    color: "#0e7490",
  },
  teal: {
    className: "text-teal-700",
    color: "#0f766e",
  },
  emerald: {
    className: "text-emerald-700",
    color: "#15803d",
  },
  lime: {
    className: "text-lime-700",
    color: "#4d7c0f",
  },
  amber: {
    className: "text-amber-700",
    color: "#b45309",
  },
  orange: {
    className: "text-orange-700",
    color: "#c2410c",
  },
  red: {
    className: "text-red-700",
    color: "#b91c1c",
  },
};

function readMetricValue(observationOrValue) {
  if (typeof observationOrValue === "number" && Number.isFinite(observationOrValue)) {
    return observationOrValue;
  }

  return typeof observationOrValue?.value === "number" &&
    Number.isFinite(observationOrValue.value)
    ? observationOrValue.value
    : null;
}

export function getEnvironmentalMetricVisual(metricKey, observationOrValue) {
  const value = readMetricValue(observationOrValue);

  if (value === null) {
    return METRIC_VISUALS.default;
  }

  switch (metricKey) {
    case "aqi":
      if (value >= 80) {
        return METRIC_VISUALS.emerald;
      }
      if (value >= 60) {
        return METRIC_VISUALS.lime;
      }
      if (value >= 40) {
        return METRIC_VISUALS.amber;
      }
      if (value >= 20) {
        return METRIC_VISUALS.orange;
      }
      return METRIC_VISUALS.red;
    case "temperature":
      if (value < 10) {
        return METRIC_VISUALS.sky;
      }
      if (value < 20) {
        return {
          className: "text-primary",
          color: colours.primary,
        };
      }
      if (value < 28) {
        return METRIC_VISUALS.amber;
      }
      return METRIC_VISUALS.red;
    case "humidity":
      if (value < 30) {
        return METRIC_VISUALS.amber;
      }
      if (value <= 70) {
        return METRIC_VISUALS.emerald;
      }
      return METRIC_VISUALS.sky;
    case "pollen":
      if (value <= 1) {
        return METRIC_VISUALS.emerald;
      }
      if (value <= 2) {
        return METRIC_VISUALS.lime;
      }
      if (value <= 3) {
        return METRIC_VISUALS.amber;
      }
      if (value <= 4) {
        return METRIC_VISUALS.orange;
      }
      return METRIC_VISUALS.red;
    default:
      return METRIC_VISUALS.default;
  }
}

export function getEnvironmentalMetricValueClass(metricKey, observationOrValue) {
  return getEnvironmentalMetricVisual(metricKey, observationOrValue).className;
}

export function getEnvironmentalMetricColor(metricKey, observationOrValue) {
  return getEnvironmentalMetricVisual(metricKey, observationOrValue).color;
}
